import React from 'react'
import PropTypes from 'prop-types'
import { IconVisit } from '../../../assets'
import { Arrow, COLOR } from '../../../assets'
import { Text } from '../../'
import {  VisitButton,
          ContainerColumn,
          CharacterIcon,
          ContainerText,
          ArrowLeftContainer,
          RightArrow } from './start-visit.styled'

const ButtonStartVisitComponent = React.memo(({ call, fill }) => {
  return (
    <VisitButton onClick={call || null}>
      <ContainerColumn>
        <CharacterIcon src={IconVisit} fill={fill} alt="Start visit" />
        <ContainerText>
            <Text
              fontFamily=""
              fontSize="10px"
              color={COLOR.quinary}
              textId="splash.start-visit"
            />
          <ArrowLeftContainer>
            <RightArrow className="arrow-right" src={Arrow} alt="Start visit" />
          </ ArrowLeftContainer>
        </ContainerText>
      </ContainerColumn>
    </VisitButton>
  )
})

ButtonStartVisitComponent.propTypes = {
  call: PropTypes.func,
  fill: PropTypes.string
}

ButtonStartVisitComponent.defaultPropTypes = {
  call: () => {},
  fill: '#000'
}

export default React.memo(ButtonStartVisitComponent)
